import React, { useState } from 'react';
import { Eyebrow, SectionStamp } from '../components/Atoms';
import Icon from '../components/Icon';
import TopBar from '../components/TopBar';
import TabBar from '../components/TabBar';
import WhatsAppFab from '../components/WhatsAppFab';
import { fonts } from '../theme';

const ROWS = [
  { ic: 'phone', k: '+91 6353 937 571', v: 'Call · Mon–Sat, 9–7', href: 'tel:+916353937571' },
  { ic: 'mail', k: 'moxapatel1908@gmail.com', v: 'Email · Reply within 24h', href: 'mailto:moxapatel1908@gmail.com' },
  { ic: 'pin', k: 'Vadodara, Gujarat', v: 'Clinic & home visits', href: 'https://maps.google.com/?q=Vadodara,+Gujarat' },
];

export default function Contact({ t }) {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const update = (k, v) => setForm(p => ({ ...p, [k]: v }));

  return (
    <div style={{
      width: '100%', height: '100%', position: 'relative',
      overflow: 'hidden', background: t.paper, color: t.ink,
    }}>
      <TopBar t={t} title="Contact"/>

      <div style={{
        position: 'absolute', top: 50, left: 0, right: 0, bottom: 0,
        overflowY: 'auto', padding: '0 22px 100px',
      }}>
        <SectionStamp n="—" label="Get in touch" t={t}/>
        <h1 style={{
          fontFamily: fonts.serif, fontSize: 40, fontWeight: 300,
          letterSpacing: '-0.03em', lineHeight: 0.95, margin: '14px 0 18px',
        }}>
          Let&rsquo;s <span style={{ fontStyle: 'italic', color: t.mintDeep }}>talk.</span>
        </h1>

        {ROWS.map((row, i) => (
          <a key={i} href={row.href} target={row.href.startsWith('http') ? '_blank' : undefined} rel="noopener noreferrer" style={{
            display: 'flex', alignItems: 'center', gap: 14,
            padding: '14px 0', borderBottom: `0.5px solid ${t.hair}`,
            color: 'inherit', textDecoration: 'none',
          }}>
            <div style={{
              width: 36, height: 36, borderRadius: 10, background: t.cream,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: t.ink, flexShrink: 0,
            }}>
              <Icon name={row.ic} size={18} sw={1.6}/>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{
                fontFamily: fonts.serif, fontSize: 16, fontWeight: 400,
                letterSpacing: '-0.01em',
                whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
              }}>{row.k}</div>
              <div style={{ fontFamily: fonts.sans, fontSize: 11, color: t.muted, marginTop: 2 }}>{row.v}</div>
            </div>
            <Icon name="arrow-up-right" size={16} stroke={t.muted}/>
          </a>
        ))}

        <div style={{
          marginTop: 26, borderRadius: 14, padding: 18,
          background: t.ink, color: t.paper, position: 'relative', overflow: 'hidden',
        }}>
          <Eyebrow t={t} color={t.mint}>Home visits · Vadodara</Eyebrow>
          <div style={{
            fontFamily: fonts.serif, fontSize: 24, lineHeight: 1.05, fontWeight: 300,
            letterSpacing: '-0.02em', marginTop: 10, color: t.paper,
          }}>
            <span>Care that comes to your </span>
            <span style={{ fontStyle: 'italic', color: t.mint }}>doorstep.</span>
          </div>
          <p style={{
            fontFamily: fonts.sans, fontSize: 12, color: 'rgba(246,243,236,0.7)',
            lineHeight: 1.5, marginTop: 10,
          }}>
            Personalised physiotherapy at your home — same care, more comfort.
          </p>
          <Icon name="home" size={120} stroke={t.mint} sw={0.6}
            style={{ position: 'absolute', right: -20, top: -20, opacity: 0.12 }}/>
        </div>

        <div style={{ marginTop: 30 }}>
          <SectionStamp n="—" label="Or send a note" t={t}/>
          {submitted ? (
            <div style={{
              marginTop: 14, padding: 18, borderRadius: 12,
              background: t.mint, color: t.ink,
              display: 'flex', alignItems: 'center', gap: 12,
            }}>
              <Icon name="check" size={20} stroke={t.ink} sw={2}/>
              <div style={{ fontFamily: fonts.serif, fontSize: 16 }}>
                Thank you. I&rsquo;ll be in touch shortly.
              </div>
            </div>
          ) : (
            <form
              style={{ marginTop: 14 }}
              onSubmit={(e) => { e.preventDefault(); setSubmitted(true); }}
            >
              {[
                { k: 'name', label: 'Name', placeholder: 'Your name' },
                { k: 'email', label: 'Email', placeholder: 'someone@example.com', type: 'email' },
              ].map(f => (
                <div key={f.k} style={{ marginBottom: 12 }}>
                  <label style={{
                    fontFamily: fonts.mono, fontSize: 9.5, color: t.muted,
                    letterSpacing: '0.16em', textTransform: 'uppercase',
                    display: 'block', marginBottom: 6,
                  }}>{f.label}</label>
                  <input
                    type={f.type || 'text'}
                    value={form[f.k]}
                    onChange={(e) => update(f.k, e.target.value)}
                    placeholder={f.placeholder}
                    style={{
                      width: '100%', padding: 14, background: 'transparent', color: t.ink,
                      border: `0.5px solid ${t.hair}`, borderRadius: 10,
                      fontFamily: fonts.sans, fontSize: 14, outline: 'none',
                    }}
                  />
                </div>
              ))}
              <div style={{ marginBottom: 12 }}>
                <label style={{
                  fontFamily: fonts.mono, fontSize: 9.5, color: t.muted,
                  letterSpacing: '0.16em', textTransform: 'uppercase',
                  display: 'block', marginBottom: 6,
                }}>Message</label>
                <textarea
                  value={form.message}
                  onChange={(e) => update('message', e.target.value)}
                  placeholder="What can I help with?"
                  style={{
                    width: '100%', padding: 12, minHeight: 90, background: 'transparent', color: t.ink,
                    border: `0.5px solid ${t.hair}`, borderRadius: 10,
                    fontFamily: fonts.sans, fontSize: 14, resize: 'none', outline: 'none',
                  }}
                />
              </div>
              <button type="submit" style={{
                appearance: 'none', border: 'none', cursor: 'pointer',
                background: t.ink, color: t.paper, width: '100%', padding: 14, borderRadius: 999,
                fontFamily: fonts.sans, fontSize: 13, fontWeight: 500,
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              }}>
                <span>Send message</span>
                <Icon name="arrow-up-right" size={14}/>
              </button>
            </form>
          )}
        </div>
      </div>

      <WhatsAppFab bottom={100}/>
      <TabBar t={t}/>
    </div>
  );
}
